import {State} from '@popperjs/core';
import {top, bottom, right, left} from '@popperjs/core';

export const sameWidth = {
  name: 'sameWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: (state: State) => {
    state.styles.popper.width = `${state.rects.reference.width}px`;
  },
  effect: (state: State) => {
    state.elements.popper.style.width = `${
      state.elements.reference.getBoundingClientRect().width
    }px`;
  },
};

export const preventOverflow = {
  name: 'preventOverflow',
  options: {
    boundary: document.body,
    rootBoundary: 'viewport',
    altBoundary: true,
  },
};

export const flip = {
  name: 'flip',
  options: {
    fallbackPlacements: [left, right, bottom, top],
  },
};

export const offset = {
  name: 'offset',
  options: {
    offset: [0, 5],
  },
};

export const arrow = {
  name: 'arrow',
  options: {
    padding: 5, // 5px from the edges of the popper
  },
};
